module.exports = __webpack_public_path__ + "static/media/LogoWebAdministracionSmaller.b548e40a.png";